<template>
  <div>
    <v-card>
      <v-card-text>
        <v-data-table
          dense
          mobile-breakpoint="0"
          disable-filtering
          disable-pagination
          disable-sort
          :hide-default-footer="true"
          :headers="headers"
          :items="concentrator_table"
          class = "custom-header"
        >
          <template v-slot:footer>
            <v-row
              align="center"
              justify="space-around"
            >
              <v-btn color="cyan" dark @click="addRow">{{ $t("Add Another Concentrator Model") }}</v-btn>
            </v-row>
          </template>
          <template v-slot:header.num_concentrator="{header}">
            <span>
              {{ $t(header.text) }}
            </span>
          </template>
          <template v-slot:header.type="{header}">
            <span>
              {{ $t(header.text) }}
            </span>
          </template>
          <template v-slot:header.liters="{header}">
            <span>
              {{ $t(header.text) }}
            </span>
          </template>
          <template v-slot:header.total="{header}">
            <span>
              {{ $t(header.text) }}
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small color="#ccc" @click="deleteRow(item)">{{ mdiDelete }}</v-icon>
          </template>
          <template v-slot:item.num_concentrator="{ item }">
            <div style="display:flex; justify-content: flex-end;">
              <v-text-field
                v-model = "item.num_concentrator"
                class="right"
                single-line
                type="number"
                style="width: 80px; flex: 0 1 auto;"
                :min="0"
                :rules="rules.value"
              ></v-text-field>
            </div>
          </template>
          <template v-slot:item.type="{ item }">
            <div>
              <v-select
                style = "max-width: 300px; margin-bottom: 0.5em;"
                :items="supply_types_concentrator"
                item-value="item.text"
                v-model="item.type"
                hide-details
                dense
                @change = "updateItemLiters(item)"
              >
                <template v-slot:selection="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item['Manufacturer'] + ' ' + data.item['Model'] }}
                </template>
                <template v-slot:item="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item['Manufacturer'] + ' ' + data.item['Model'] }}
                </template>
              </v-select>
            </div>
          </template>
          <template v-slot:item.liters="{ item }">
            <div style="display:flex; justify-content: flex-end;">
              <v-text-field
                v-model = "item.liters"
                class="right"
                single-line
                type="number"
                style="width: 100px; flex: 0 1 auto;"
                :min="0"
                :rules="rules.value"
              ></v-text-field>
            </div>
          </template>
          <template v-slot:item.total="{ item }">
            <span style="font-size:16px;">
              {{ numberToString(calcSupply(item)) }}
            </span>
          </template>

        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mdiDelete, mdiInformationOutline } from '@mdi/js'

export default {
  name: 'SupplyTableEditableConcentrator',

  components: { },

  methods: {
    numberToString: (x) => (
      isNaN(x) ?
        x :
        x.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 1})
    ),
    get_supply_types: function(source) {
      let types = this.supply_types ? this.supply_types.filter((d) => d.Manufacturer !== '') : []
      if(types.length === 0) {
        return types
      }
      if(source === "plant") {
        return types.filter( d => d["Oxygen supply type"] === "PSA Plant" || d["Oxygen supply type"] === "VSA Plant" || d["Oxygen supply type"] === "")
      }
      if(source === "concentrator") {
        return types.filter( d => d["Oxygen supply type"] === "Portable PSA" || d["Oxygen supply type"] === "")
      }
      if(source === "liquid") {
        return types.filter( d => d["Oxygen supply type"] === "Liquid Oxygen" || d["Oxygen supply type"] === "")
      }
    },
    addRow: function() {
      this.concentrator_table.push(
        Object.assign({},this.defaults[0])
      )
    },
    deleteRow (item) {
      const editedIndex = this.concentrator_table.indexOf(item)
      this.concentrator_table.splice(editedIndex, 1)
    },
    calcSupply (item) {
      return +item.num_concentrator * item.liters * 60 * this.hours_concentrator_supply_only * ( 100 - this.leakage_concentrator_supply_only ) / 100
    },
    concentratorTableHandler: function() {
      this.$store.commit('changeSupplyOnlyConcentratorTable', JSON.parse(JSON.stringify(this.concentrator_table)))
    },
    updateItemLiters: function(item) {
      item.liters = item.type.lpm ? item.type.lpm : 0
    }
  },

  data: function() {
    return {
      showoverlay: false,
      showdialog: false,
      dialogtext: '',
      mdiDelete,
      mdiInformationOutline,
      rules: {
        value: [
          val => {return val >= 0 || `Amount should be 0 or more`},
        ],
      },
      concentrator_table: JSON.parse(JSON.stringify(this.$store.state.concentrator_table_editable)),
      headers: [
        {text: '', value: 'actions', sortable: false, width: '10px', align: 'center'},
        {text: '# at Facility', value: 'num_concentrator', align: 'end', width: '100px'},
        {text: 'Manufacturer/Type', value: 'type'},
        {text: 'Maximum Volume of O₂ in Liters per Minute (LPM)', value: 'liters', align: 'end'},
        {text: 'Total Fixed Supply (L)', value: 'total', align: 'end'}
      ],
      defaults: [
        {
          "type": {},
          "num_concentrator": 0,
          "liters": 0,
        }
      ]
    }
  },

  computed: {
    ...mapFields([
      'demandsnackbar',
      'demandsnackbartext',
      'calculator',
      'leakage_concentrator_supply_only',
      'hours_concentrator_supply_only',
      'supply_types',
      'reset_supply_only_trigger',
    ]),
    supply_types_concentrator: function() {
      return this.supply_types ? this.get_supply_types('concentrator') : []
    }
  },

  watch: {
    concentrator_table: {
      deep: true,
      handler: function() {this.concentratorTableHandler()},
      immediate: true
    },
    reset_supply_only_trigger: function() {
      this.concentrator_table.splice(0)
    }
  }
}
</script>

<style>
  .v-data-table td, .v-data-table th {
    padding: 0 4px;
  }
</style>

<style scoped>
  .sliderlabel {
    font-size: 75%;
    color: rgba(0, 0, 0, 0.6);
  }
  .custom-header.theme--light.v-data-table >>> thead tr:last-child th {
      border-bottom: 2px solid rgba(0, 0, 0, 0.25);
      font-size: 110%;
      vertical-align: bottom;
  }
</style>